/**
 * Domain-specific TAP trait constants and key normalization for the Rovo Settings Modal.
 */

/**
 * Per-product % of MAU users exposed to a rendered smartlink for that 3P.
 * Trait value format: "product:pct, product:pct, ..." (e.g. "figma:45, drive:30, slack:72").
 */
export const SMARTLINK_APP_EXPOSURE_RATE_TRAIT = 'smartlink_app_exposure_rate';
